import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import EditClientModal from '../components/EditClientModal';
import RequestResgateModal from '../components/RequestResgateModal';
import SelectPromoModal from './SelectPromoModal';
import PromoList from '../components/PromoList';
import LaunchPointsModal from '../components/LaunchPointsModal';
import GraphicsDashboard from './GraphicsDashboard';
import AddClientModal from '../components/AddClientModal';
import AlertList from '../components/AlertList';
import EditCompanyModal from '../components/EditCompanyModal';
import AddAlertModal from '../components/AddAlertModal';
import AlertModal from '../components/AlertModal';
import GenerateLinkModal from '../components/GenerateLinkModal';
import ClientHistoryModal from '../components/ClientHistoryModal';
import AddCompanyModal from '../components/AddCompanyModal';
import ClientAnnotationsModal from './ClientAnnotationsModal';
import RateReviews from './RateReviews';
import PreClientsImport from '../components/PreClientsImport';
import ReportsDashboard from './ReportsDashboard';
import TelegramQrCodeModal from '../components/TelegramQrCodeModal';
import Footer from '../components/Footer';
import '../styles/formStyles.css';
import * as XLSX from 'xlsx';

const API_URL = process.env.REACT_APP_API_BASE_URL;
const USER_IMAGE_DEFAULT = process.env.REACT_APP_USER_IMAGE_DEFAULT;
const WHATSAPP_SIGNATURE = '@fidelitystoreapp sua plataforma de fidelidade';

function StoreOwnerDashboard() {
  const navigate = useNavigate();
  const [selectedMenu, setSelectedMenu] = useState('clientes');
  const [menuOpen, setMenuOpen] = useState(false);
  const [clientToEdit, setClientToEdit] = useState(null);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [clientForResgate, setClientForResgate] = useState(null);
  const [selectPromoModalVisible, setSelectPromoModalVisible] = useState(false);
  const [selectedPromo, setSelectedPromo] = useState(null);
  const [resgateModalVisible, setResgateModalVisible] = useState(false);
  const [clientForPoints, setClientForPoints] = useState(null);
  const [pointsModalVisible, setPointsModalVisible] = useState(false);
  const [clientForHistory, setClientForHistory] = useState(null);
  const [historyModalVisible, setHistoryModalVisible] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [addClientModalVisible, setAddClientModalVisible] = useState(false);
  const [addCompanyModalVisible, setAddCompanyModalVisible] = useState(false);
  const [editCompanyModalVisible, setEditCompanyModalVisible] = useState(false);
  const [generateLinkModalVisible, setGenerateLinkModalVisible] = useState(false);
  const [clientForRegistrationLink, setClientForRegistrationLink] = useState(null);
  const [companyToEdit, setCompanyToEdit] = useState(null);
  const [currentCompany, setCurrentCompany] = useState(null);
  const [qtdCompanies, setQtdCompanies] = useState(0);
  const [nomeFantasia, setNomeFantasia] = useState('');
  const [logoUrl, setLogoUrl] = useState('');
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertType, setAlertType] = useState('info');
  const [alertMessage, setAlertMessage] = useState('');
  const [annotationsModalVisible, setAnnotationsModalVisible] = useState(false);
  const [clientForAnnotations, setClientForAnnotations] = useState(null);
  const [telegramQrData, setTelegramQrData] = useState(null);
  const [telegramQrLoading, setTelegramQrLoading] = useState(false);
  const [telegramQrError, setTelegramQrError] = useState(null);
  const [telegramQrModalVisible, setTelegramQrModalVisible] = useState(false);
  const [createAlertFromFilterModalVisible, setCreateAlertFromFilterModalVisible] = useState(false);
  const [filterRecipients, setFilterRecipients] = useState([]);
  const [whatsappModalVisible, setWhatsappModalVisible] = useState(false);
  const [clientForWhatsapp, setClientForWhatsapp] = useState(null);
  const [whatsappAlerts, setWhatsappAlerts] = useState([]);
  const [selectedWhatsappAlertId, setSelectedWhatsappAlertId] = useState('');
  const [whatsappMessage, setWhatsappMessage] = useState('');
  const [whatsappAlertsLoading, setWhatsappAlertsLoading] = useState(false);
  const [whatsappConfirmVisible, setWhatsappConfirmVisible] = useState(false);

  const showAlert = (type, message) => {
    setAlertType(type);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  const handleTelegramQrCode = async () => {
    const companyId = localStorage.getItem('company_id');
    if (!companyId) {
      setTelegramQrError('ID da empresa não encontrado.');
      setTelegramQrModalVisible(true);
      return;
    }

    setTelegramQrLoading(true);
    setTelegramQrError(null);
    setTelegramQrData(null);
    setTelegramQrModalVisible(true);

    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`${API_URL}/companies/${companyId}/telegram-qrcode`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        setTelegramQrData(data);
        setTelegramQrError(null);
      } else if (response.status === 404) {
        const errorData = await response.json();
        setTelegramQrError(errorData.message || 'Grupo Telegram não configurado para esta empresa.');
        setTelegramQrData(null);
      } else {
        setTelegramQrError('Erro ao buscar QR code do Telegram. Tente novamente.');
        setTelegramQrData(null);
      }
    } catch (error) {
      console.error('Erro ao buscar QR code Telegram:', error);
      setTelegramQrError('Erro de conexão. Tente novamente.');
      setTelegramQrData(null);
    } finally {
      setTelegramQrLoading(false);
    }
  };

  // Estados para os filtros
  const [filterNome, setFilterNome] = useState('');
  const [filterEmail, setFilterEmail] = useState('');
  const [filterMinAge, setFilterMinAge] = useState('');
  const [filterMaxAge, setFilterMaxAge] = useState('');
  const [filterLocation, setFilterLocation] = useState('');
  const [filterGender, setFilterGender] = useState('todos');
  const [filterBirthDate, setFilterBirthDate] = useState(''); // filtro de aniversário (data de nascimento)
  const [filterStatus, setFilterStatus] = useState('ativos');

  const [clientsData, setClientsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'asc' });
  
  // Função auxiliar para converter datas no formato "YYYY-MM-DD" ou "YYYY-MM-DD HH:MM:SS"
  // em um objeto Date local, evitando problemas de fuso horário que mudam o dia.
  const parseISODateOnly = (value) => {
    if (!value || typeof value !== 'string') return null;
    const [datePart] = value.split(' ');
    const parts = datePart.split('-');
    if (parts.length < 3) return null;
    const year = Number(parts[0]);
    const month = Number(parts[1]);
    const day = Number(parts[2]);
    if (!year || !month || !day) return null;
    return new Date(year, month - 1, day);
  };

  // Função para formatar data para o padrão brasileiro (dd/mm/aaaa)
  const formatDate = (dateString) => {
    const date = parseISODateOnly(dateString);
    if (!date) return 'N/A';
    return date.toLocaleDateString('pt-BR');
  };

  // Converte a URL do Google Drive para um link de imagem direto usando um proxy
  const getGoogleDriveImageProxyUrl = (url) => {
    if (typeof url !== 'string' || !url.includes('drive.google.com')) {
      return url; // Retorna a URL original se não for do Google Drive
    }
  
    // Extrai o ID do arquivo da URL
    const match = url.match(/file\/d\/([^/]+)/);
    if (match && match[1]) {
      const fileId = match[1];
      // Usa um proxy para forçar o download direto da imagem
      return `https://images.weserv.nl/?url=https://drive.google.com/uc?id=${fileId}`;
    }
  
    return url; // Retorna a URL original se não conseguir extrair o ID
  };

  // Recupera dados do usuário do localStorage para exibir o e-mail e a imagem de perfil.
  useEffect(() => {
    const userData = localStorage.getItem('user');
    const nomeFantasiaStorage = localStorage.getItem('nomeFantasia');
    const urlLogoStorage = localStorage.getItem('urlLogo');
    const companyId = localStorage.getItem('company_id');
     if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        setUserEmail(parsedUser.email || '');
        setNomeFantasia(nomeFantasiaStorage || '');
        const proxyLogoUrl = getGoogleDriveImageProxyUrl(urlLogoStorage);
        setLogoUrl(proxyLogoUrl || '');

        if (companyId) {
          setCurrentCompany({
            id: companyId,
            nomeFantasia: nomeFantasiaStorage,
            urlLogo: proxyLogoUrl,
          });
        }
        
        const qtdCompaniesFromStorage = localStorage.getItem('qtd_companies');
        setQtdCompanies(Number(qtdCompaniesFromStorage) || 0);
      } catch (e) {
        console.error('Erro ao ler os dados do usuário:', e);
      }
    }
  }, []);

  const token = localStorage.getItem('token');

  const getPhoneDigits = (phone) => String(phone || '').replace(/\D/g, '');

  const hasPhone = (phone) => getPhoneDigits(phone).length > 0;

  const handleGenerateClientLink = (client) => {
    setClientForRegistrationLink(client);
    setGenerateLinkModalVisible(true);
  };

  const getWhatsappPhone = (phone) => {
    const digits = getPhoneDigits(phone);
    return digits.startsWith('55') ? digits : `55${digits}`;
  };

  const appendWhatsappSignature = (message) => {
    const text = String(message || '').trimEnd();
    if (!text) return WHATSAPP_SIGNATURE;
    if (text.includes(WHATSAPP_SIGNATURE)) return text;
    return `${text}\n\n${WHATSAPP_SIGNATURE}`;
  };

  const fetchWhatsappAlerts = async () => {
    const companyId = localStorage.getItem('company_id');
    if (!companyId) {
      setWhatsappAlerts([]);
      showAlert('warning', 'ID da empresa nao encontrado.');
      return;
    }

    setWhatsappAlertsLoading(true);
    try {
      const response = await fetch(`${API_URL}/alerts?company_id=${companyId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        const availableAlerts = Array.isArray(data)
          ? data
              .filter((alert) => Number(alert.status) === 1)
              .map((alert) => ({
                id: alert.id,
                nome: alert.alert_name,
                mensagem: alert.alert_msg || '',
              }))
          : [];

        setWhatsappAlerts(availableAlerts);
      } else {
        setWhatsappAlerts([]);
        showAlert('error', 'Erro ao buscar alertas para WhatsApp.');
      }
    } catch (error) {
      setWhatsappAlerts([]);
      console.error('Erro ao buscar alertas para WhatsApp:', error);
      showAlert('error', 'Erro de conexao ao buscar alertas para WhatsApp.');
    } finally {
      setWhatsappAlertsLoading(false);
    }
  };

  const handleOpenWhatsappModal = (client) => {
    if (!hasPhone(client?.telefone)) {
      showAlert('warning', 'Cliente sem telefone informado.');
      return;
    }

    setClientForWhatsapp(client);
    setSelectedWhatsappAlertId('');
    setWhatsappMessage('');
    setWhatsappModalVisible(true);
    fetchWhatsappAlerts();
  };

  const handleCloseWhatsappModal = () => {
    setWhatsappModalVisible(false);
    setWhatsappConfirmVisible(false);
    setClientForWhatsapp(null);
    setSelectedWhatsappAlertId('');
    setWhatsappMessage('');
    setWhatsappAlerts([]);
  };

  const handleWhatsappAlertChange = (event) => {
    const selectedId = event.target.value;
    setSelectedWhatsappAlertId(selectedId);

    if (!selectedId) {
      setWhatsappMessage('');
      return;
    }

    const selectedAlert = whatsappAlerts.find((alert) => String(alert.id) === selectedId);
    setWhatsappMessage(selectedAlert?.mensagem || '');
  };

  const handleSendWhatsappMessage = () => {
    const message = whatsappMessage.trim();
    if (!message) {
      showAlert('warning', 'Informe a mensagem antes de enviar.');
      return;
    }

    if (!clientForWhatsapp || !hasPhone(clientForWhatsapp.telefone)) {
      showAlert('warning', 'Cliente sem telefone informado.');
      return;
    }

    setWhatsappConfirmVisible(true);
  };

  const handleCancelWhatsappConfirmation = () => {
    setWhatsappConfirmVisible(false);
  };

  const handleConfirmWhatsappSend = () => {
    const message = appendWhatsappSignature(whatsappMessage);
    const phone = getWhatsappPhone(clientForWhatsapp.telefone);
    const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    handleCloseWhatsappModal();
  };

  // Função para buscar dados dos clientes da API
  useEffect(() => {
    const fetchClientsData = async () => {
      try {
        const companyId = localStorage.getItem('company_id');
        const url = `${API_URL}/clients/all-clients?company_id=${companyId}`;
        const response = await fetch(url, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
          const data = await response.json();
          setClientsData(Array.isArray(data) ? data : []);
        } else {
          const errorData = await response.json();
          if (
            response.status === 404 &&
            errorData &&
            errorData.message === 'No results found'
          ) {
            setClientsData([]);
          } else {
            console.error('Erro ao buscar dados dos clientes:', errorData);
          }
        }
      } catch (error) {
        console.error('Erro ao buscar dados dos clientes:', error);
      }
    };

    fetchClientsData();
  }, [token]);

  const handleLogoff = () => {
    localStorage.removeItem('user');
    navigate('/login');
  };

  const handleEdit = (client) => {
    setClientToEdit(client);
    setEditModalVisible(true);
  };

  const handleResgate = (client) => {
    setClientForResgate(client);
    setSelectPromoModalVisible(true);
  };

  const handleLaunchPoints = (client) => {
    setClientForPoints(client);
    setPointsModalVisible(true);
  };

  const handleHistory = (client) => {
    setClientForHistory(client);
    setHistoryModalVisible(true);
  };

  const handleHistoryModalClose = () => {
    setHistoryModalVisible(false);
    setClientForHistory(null);
  };

  const handleOpenAnnotationsModal = (client) => {
    setClientForAnnotations(client);
    setAnnotationsModalVisible(true);
  };

  const handleAnnotationsModalClose = () => {
    setAnnotationsModalVisible(false);
    setClientForAnnotations(null);
  };
  const handleEditModalClose = () => {
    setEditModalVisible(false);
    setClientToEdit(null);
  };

  const handleResgateModalClose = () => {
    setResgateModalVisible(false);
    setClientForResgate(null);
    setSelectedPromo(null);
  };

  const handlePointsModalClose = () => {
    setPointsModalVisible(false);
    setClientForPoints(null);
  };

  const handleEditCompanyModalClose = () => {
    setEditCompanyModalVisible(false);
    setCompanyToEdit(null);
  };

  const handleCompanyUpdated = () => {
    const userData = localStorage.getItem('user');
    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        parsedUser.primeiroAcesso = 0;
        localStorage.setItem('user', JSON.stringify(parsedUser));
      } catch (e) {
        console.error("Falha ao atualizar 'primeiroAcesso' no localStorage", e);
      }
    }
    handleEditCompanyModalClose();
    window.location.reload(); // Recarrega para refletir possíveis mudanças no nome/logo
  };

  // Atualiza o cliente editado na lista
  const handleClientUpdated = () => {
    setClientsData((prevData) =>
      prevData.map((c) =>
        c.id === clientToEdit.id ? clientToEdit : c
      )
    );
  };

  // Atualiza os pontos do cliente após o lançamento
  const handlePointsLaunched = (clientCodigo, pontosAdicionados) => {
    setClientsData((prevData) =>
      prevData.map((cliente) =>
        cliente.id === clientCodigo
          ? { ...cliente, pontos: cliente.pontos + pontosAdicionados }
          : cliente
      )
    );
    handlePointsModalClose();
  };

  const handleAddClient = () => {
    setAddClientModalVisible(true);
  };

  const handleAddClientModalClose = () => {
    setAddClientModalVisible(false);
  };

  const handleClientAdded = (newClient) => {
    setClientsData([...clientsData, newClient]);
    handleAddClientModalClose();
  };

  const handleResgateCompleted = (clientId, pontosResgatados) => {
    setClientsData(prevData =>
      prevData.map(cliente =>
        cliente.id === clientId
          ? { ...cliente, saldo_pontos: Number(cliente.saldo_pontos) - Number(pontosResgatados) }
          : cliente
      )
    );
    handleResgateModalClose();
  };

  // Combina filtragem e ordenação em uma única etapa com useMemo para otimização
  const processedClients = useMemo(() => {
    let filteredData = clientsData.filter((cliente) => {
      let matches = true;
      if (filterNome.trim() && !cliente.nome.toLowerCase().includes(filterNome.toLowerCase())) {
        matches = false;
      }
      if (filterEmail.trim() && !cliente.email.toLowerCase().includes(filterEmail.toLowerCase())) {
        matches = false;
      }
      const getAge = (birthDateStr) => {
        const birthDate = parseISODateOnly(birthDateStr);
        if (!birthDate) return 0;
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age;
      };
      const age = getAge(cliente.dataNascimento);
      if (filterMinAge.trim() && !isNaN(filterMinAge) && age < Number(filterMinAge)) {
        matches = false;
      }
      if (filterMaxAge.trim() && !isNaN(filterMaxAge) && age > Number(filterMaxAge)) {
        matches = false;
      }
      if (filterLocation.trim()) {
        const locationSearch = filterLocation.toLowerCase();
        if (
          !(cliente.bairro ?? '').toLowerCase().includes(locationSearch) &&
          !(cliente.cidade ?? '').toLowerCase().includes(locationSearch)
        ) {
          matches = false;
        }
      }
      if (filterGender !== 'todos' && (cliente.genero ?? '').toLowerCase() !== filterGender.toLowerCase()) {
        matches = false;
      }
      if (filterStatus === 'ativos' && Number(cliente.status) !== 1) {
        matches = false;
      }
      if (filterStatus === 'inativos' && Number(cliente.status) !== 0) {
        matches = false;
      }
      // Filtro por data de nascimento (aniversário): compara apenas dia e mês digitados (dd/mm)
      if (filterBirthDate.trim()) {
        const digits = filterBirthDate.replace(/\D/g, '');
        // Espera ao menos 4 dígitos (ddmm); se não tiver, não aplica o filtro de aniversário
        if (digits.length >= 4) {
          const day = Number(digits.slice(0, 2));
          const month = Number(digits.slice(2, 4));
          const birth = parseISODateOnly(cliente.dataNascimento);
          const birthTime = birth ? birth.getTime() : NaN;
          if (
            !birth ||
            Number.isNaN(birthTime) ||
            Number.isNaN(day) ||
            Number.isNaN(month) ||
            birth.getDate() !== day ||
            birth.getMonth() + 1 !== month
          ) {
            matches = false;
          }
        }
      }
      return matches;
    });

    filteredData.sort((a, b) => {
      if (filterStatus === 'todos') {
        const statusA = Number(a.status);
        const statusB = Number(b.status);
        if (statusA !== statusB) {
          return statusB - statusA;
        }
      }
      if (sortConfig.key) {
        if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'asc' ? -1 : 1;
        if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
    return filteredData;
  }, [clientsData, filterNome, filterEmail, filterMinAge, filterMaxAge, filterLocation, filterGender, filterBirthDate, filterStatus, sortConfig]);

  // Função para calcular os dados paginados
  const getPaginatedData = () => {
    if (itemsPerPage === 'all') {
      return processedClients;
    }
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return processedClients.slice(startIndex, endIndex);
  };

  // Função para alterar a página
  const handlePageChange = (direction) => {
    const totalPages = Math.ceil(processedClients.length / itemsPerPage);
    if (direction === 'next' && currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    } else if (direction === 'prev' && currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  // Função para alterar o número de itens por página
  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    if (value === 'all') {
      setItemsPerPage('all');
    } else {
      setItemsPerPage(Number(value));
    }
    setCurrentPage(1);
  };

  // Função para ordenar os dados
  const sortClients = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });

    // Apenas atualiza a configuração de ordenação, o useMemo cuidará do resto.
  };

  const handleExportXLS = () => {
    if (!processedClients || processedClients.length === 0) {
      showAlert('warning', 'Não há dados para exportar.');
      return;
    }

    // Mapeia os dados para o formato desejado e traduz os cabeçalhos
    const dataToExport = processedClients.map(cliente => ({
      'Nome': cliente.nome,
      'E-mail': cliente.email,
      'Telefone': cliente.telefone,
      'Data de Nascimento': formatDate(cliente.dataNascimento),
      'Gênero': cliente.genero,
      'Município': cliente.cidade,
      'Bairro': cliente.bairro,
      'Membro Desde': formatDate(cliente.created_at),
      'Última Visita': formatDate(cliente.ultima_visita),
      'Pontos': Number(cliente.saldo_pontos).toFixed(1),
    }));

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Clientes");
    XLSX.writeFile(wb, 'lista_clientes.xlsx');
  };

  const handleCreateAlertFromFilter = () => {
    if (!processedClients || processedClients.length === 0) {
      showAlert('warning', 'Não há clientes filtrados para criar um alerta.');
      return;
    }

    // Verifica se existem filtros que forçam uma lista estática (snapshot)
    // Filtros de texto (Nome, Email) e de Data de Nascimento (aniversário) são específicos demais para tags genéricas
    const hasStaticFilters = 
      (filterNome && filterNome.trim() !== '') || 
      (filterEmail && filterEmail.trim() !== '') ||
      (filterBirthDate && filterBirthDate.trim() !== '');

    if (hasStaticFilters) {
      // Comportamento Snapshot: Pega os e-mails atuais
      const emails = processedClients.map(c => c.email).filter(email => email && email.includes('@'));
      setFilterRecipients(emails);
    } else {
      // Comportamento Dinâmico: Cria tags baseadas nos filtros de Gênero e Idade
      const dynamicRecipients = [];

      if (filterGender && filterGender !== 'todos') {
        dynamicRecipients.push(`gender:${filterGender}`);
      }

      if (filterMinAge) {
        let max = filterMaxAge;
        if (filterMinAge === '60' && !max) max = '999'; // Trata o caso "Acima de 60"
        if (max) dynamicRecipients.push(`age:${filterMinAge}-${max}`);
      }

      if (filterLocation && filterLocation.trim() !== '') {
        dynamicRecipients.push(`location:${filterLocation}`);
      }

      // Se não gerou nenhuma tag específica e não tem filtros estáticos, é "Todos"
      if (dynamicRecipients.length === 0) {
        dynamicRecipients.push('all');
      }

      setFilterRecipients(dynamicRecipients);
    }
    
    setCreateAlertFromFilterModalVisible(true);
  };

  const handlePromoSelectedForResgate = (promo) => {
    setSelectedPromo(promo);
    setSelectPromoModalVisible(false);
    setResgateModalVisible(true);
  };

  // Função para obter o ícone de ordenação
  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? '▲' : '▼';
    }
    return '';
  };

  const renderContent = () => {
    switch (selectedMenu) {
      case 'clientes':
        return (
          <>
            <h3>Clientes Ativos</h3>
            <div style={{ marginBottom: '20px' }}>
              <div style={{ 
                display: 'flex', 
                flexWrap: 'wrap', 
                gap: '20px',
                marginBottom: '20px',
                padding: '15px',
                backgroundColor: '#f5f5f5',
                borderRadius: '8px'
              }}>
                <div className="filter-group">
                  <label htmlFor="filterNome">Nome:</label><br />
                  <input
                    id="filterNome"
                    type="text"
                    placeholder="Filtrar por nome..."
                    value={filterNome}
                    onChange={(e) => setFilterNome(e.target.value)}
                    className="input-style"
                  />
                </div>
                <div className="filter-group">
                  <label htmlFor="filterEmail">E-mail:</label><br />
                  <input
                    id="filterEmail"
                    type="text"
                    placeholder="Filtrar por e-mail..."
                    value={filterEmail}
                    onChange={(e) => setFilterEmail(e.target.value)}
                    className="input-style"
                  />
                </div>
                <div className="filter-group">
                  <label>Faixa Etária:</label><br />
                  <select
                    className="input-style"
                    onChange={(e) => {
                      const val = e.target.value;
                      if (!val) {
                        setFilterMinAge('');
                        setFilterMaxAge('');
                      } else {
                        const [min, max] = val.split('-');
                        setFilterMinAge(min);
                        setFilterMaxAge(max);
                      }
                    }}
                  >
                    <option value="">Todas</option>
                    <option value="0-18">Até 18 anos</option>
                    <option value="19-35">19 a 35 anos</option>
                    <option value="36-59">36 a 59 anos</option>
                    <option value="60-">Acima de 60 anos</option>
                  </select>
                </div>
                <div className="filter-group">
                  <label htmlFor="filterBirthDate">Data de Nascimento (Aniversário):</label><br />
                  <input
                    id="filterBirthDate"
                    type="text"
                    placeholder="dd/mm"
                    value={filterBirthDate}
                    onChange={(e) => setFilterBirthDate(e.target.value)}
                    className="input-style"
                  />
                </div>
                <div className="filter-group">
                  <label htmlFor="filterLocation">Município/Bairro:</label><br />
                  <input
                    id="filterLocation"
                    type="text"
                    placeholder="Filtrar localização..."
                    value={filterLocation}
                    onChange={(e) => setFilterLocation(e.target.value)}
                    className="input-style"
                  />
                </div>
                <div className="filter-group">
                  <label htmlFor="filterGender">Gênero:</label><br />
                  <select
                    id="filterGender"
                    value={filterGender}
                    onChange={(e) => setFilterGender(e.target.value)}
                    className="input-style"
                  >
                    <option value="todos">Todos</option>
                    <option value="masculino">Masculino</option>
                    <option value="feminino">Feminino</option>
                  </select>
                </div>
                <div className="filter-group">
                  <label htmlFor="filterStatus">Status:</label><br />
                  <select
                    id="filterStatus"
                    value={filterStatus}
                    onChange={(e) => setFilterStatus(e.target.value)}
                    className="input-style"
                  >
                    <option value="todos">Todos</option>
                    <option value="ativos">Ativos</option>
                    <option value="inativos">Inativos</option>
                  </select>
                </div>
              </div>
              <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <label htmlFor="itemsPerPage">Itens por página:</label>
                  <select
                    id="itemsPerPage"
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                    className="input-style"
                  >
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="all">Todos</option>
                  </select>
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button
                    onClick={handleCreateAlertFromFilter}
                    className="button-style"
                    disabled={processedClients.length === 0}
                  >
                    🔔 Criar Alerta
                  </button>
                  <button
                    onClick={handleExportXLS}
                    className="button-style"
                    disabled={processedClients.length === 0}
                  >
                    📤 Exportar XLS
                  </button>
                </div>
              </div>
            </div>
            <table className="dashboard-table">
              <thead>
                <tr>
                  {/* <th>Código</th> */}
                  <th onClick={() => sortClients('nome')}>
                    Nome {getSortIcon('nome')}
                  </th>
                  <th onClick={() => sortClients('email')}>
                    E-mail {getSortIcon('email')}
                  </th>
                  <th onClick={() => sortClients('telefone')}>
                    Telefone {getSortIcon('telefone')}
                  </th>
                  <th onClick={() => sortClients('dataNascimento')}>
                    Data de Nascimento {getSortIcon('dataNascimento')}
                  </th>
                  <th onClick={() => sortClients('genero')}>
                    Gênero {getSortIcon('genero')}
                  </th>
                  <th onClick={() => sortClients('cidade')}>
                    Município {getSortIcon('cidade')}
                  </th>
                  <th onClick={() => sortClients('bairro')}>
                    Bairro {getSortIcon('bairro')}
                  </th>
                  <th onClick={() => sortClients('created_at')}>
                    Membro Desde {getSortIcon('created_at')}
                  </th>
                  <th onClick={() => sortClients('ultima_visita')}>
                    Última Visita {getSortIcon('ultima_visita')}
                  </th>
                  <th onClick={() => sortClients('saldo_pontos')}>
                    Pontos {getSortIcon('saldo_pontos')}
                  </th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {getPaginatedData().length > 0 ? (
                  getPaginatedData().map((cliente, index) => (
                    <tr key={cliente.id} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                      {/* <td>{cliente.id}</td> */}
                      <td>{cliente.nome}</td>
                      <td>{cliente.email}</td>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <span>{cliente.telefone}</span>
                          {hasPhone(cliente.telefone) && (
                            <button
                              onClick={() => handleOpenWhatsappModal(cliente)}
                              title="Enviar WhatsApp"
                              className="action-button"
                              type="button"
                            >
                              <i className="bi bi-whatsapp" aria-hidden="true"></i>
                            </button>
                          )}
                          <button
                            onClick={() => handleGenerateClientLink(cliente)}
                            title="Gerar link personalizado"
                            className="action-button"
                            type="button"
                          >
                            <i className="bi bi-link-45deg" aria-hidden="true"></i>
                          </button>
                        </div>
                      </td>
                      <td>{formatDate(cliente.dataNascimento)}</td>
                      <td>{cliente.genero}</td>
                      <td>{cliente.cidade}</td>
                      <td>{cliente.bairro}</td>
                      <td>{formatDate(cliente.created_at)}</td>
                      <td>{formatDate(cliente.ultima_visita)}</td>
                      <td>{Number(cliente.saldo_pontos).toFixed(1)}</td>
                      <td>
                        <div style={{ display: 'flex', gap: '5px' }}>
                          <button onClick={() => handleEdit(cliente)} title="Editar" className="action-button">
                            ✎
                          </button>
                          <button onClick={() => handleResgate(cliente)} title="Resgate" className="action-button">
                            💰
                          </button>
                          <button onClick={() => handleLaunchPoints(cliente)} title="Lançar Pontos" className="action-button">
                            💵
                          </button>
                          <button onClick={() => handleHistory(cliente)} title="Histórico" className="action-button">
                            📜
                          </button>
                          <button onClick={() => handleOpenAnnotationsModal(cliente)} title="Ver Anotações" className="action-button">
                            📝
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="13" style={{ textAlign: 'center' }}>
                      Nenhum cliente encontrado.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {itemsPerPage !== 'all' && (
              <div className="pagination-controls" style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                <button
                  onClick={() => handlePageChange('prev')}
                  disabled={currentPage === 1}
                  className="button-style"
                >
                  ◀ Anterior
                </button>
                <span>
                  Página {currentPage} de {Math.ceil(processedClients.length / itemsPerPage)}
                </span>
                <button
                  onClick={() => handlePageChange('next')}
                  disabled={currentPage === Math.ceil(processedClients.length / itemsPerPage)}
                  className="button-style"
                >
                  Próximo ▶
                </button>
              </div>
            )}
          </>
        );
      case 'promocoes':
        return (
          <>
            <h3>Lista de Promoções</h3>
            <PromoList />
          </>
        );
      case 'graficos':
        return (
          <>
            <h3>Gráficos</h3>
            <GraphicsDashboard />
          </>
        );
      case 'alertas':
        return (
          <>
            <h3>Gestão de Alertas</h3>
            <AlertList />
          </>
        );
      case 'adicionarEmpresa':
        return (
          <>
            <h3>Adicionar Empresa</h3>
            <p>Formulário ou funcionalidade para adicionar uma nova empresa.</p>
          </>
        );
      case 'avaliacoes':
        return (
          <>
            <RateReviews />
          </>
        );
      case 'importacaoContatos':
        return <PreClientsImport onGenerateRegistrationLink={handleGenerateClientLink} />;
      case 'relatorios':
        return (
          <>
            <h3>Relatórios</h3>
            <ReportsDashboard />
          </>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        if (Number(parsedUser.primeiroAcesso) === 1) {
          const client = clientsData.find(c => c.id === parsedUser.client_id);
          if (client) {
            setClientToEdit({
              ...client,
              primeiroAcesso: parsedUser.primeiroAcesso,
            });
            setEditModalVisible(true);
          }
        }
      } catch (e) {
        console.error('Erro ao verificar primeiro acesso do usuário:', e);
      }
    }
  }, [clientsData]);

  // Verifica se é o primeiro acesso do LOJISTA para editar os dados da empresa
  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        if (parsedUser.perfil === 'lojista' && Number(parsedUser.primeiroAcesso) === 1) {
          const companiesData = localStorage.getItem('companies');
          const companyId = localStorage.getItem('company_id');

          if (companiesData && companyId) {
            const companies = JSON.parse(companiesData);
            const companyData = companies.find(c => String(c.id) === String(companyId));

            if (companyData) {
              setCompanyToEdit({ ...companyData, primeiroAcesso: parsedUser.primeiroAcesso });
              setEditCompanyModalVisible(true);
            }
          }
        }
      } catch (e) {
        console.error('Erro ao verificar primeiro acesso do lojista:', e);
      }
    }
  }, []);

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h2 className="dashboard-title">
          Bem-vindo(a), {userEmail}<br />
          Empresa: {nomeFantasia}
          {logoUrl ? (
            <img
              src={logoUrl}
              alt="Logo da Empresa"
              className="dashboard-profile-image"
              onError={(e) => { e.target.onerror = null; e.target.src = USER_IMAGE_DEFAULT; }}
              style={{ marginLeft: 8 }}
            />
          ) : null}
        </h2>
        <button onClick={handleLogoff} className="button-style logoff-button">
          Logoff
        </button>
      </header>

      <nav
        className="hamburger-menu"
        onMouseEnter={() => setMenuOpen(true)}
        onMouseLeave={() => setMenuOpen(false)}
      >
        <button className="hamburger-icon" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </button>
        {menuOpen && (
          <div className="menu-options">
            <button onClick={() => setSelectedMenu('clientes')} className="menu-option">
              Clientes
            </button>
            <button onClick={() => setSelectedMenu('alertas')} className="menu-option">
              Alertas
            </button>
            <button onClick={() => setSelectedMenu('promocoes')} className="menu-option">
              Promoções
            </button>
            <button onClick={() => setGenerateLinkModalVisible(true)} className="menu-option" disabled={!currentCompany}>
              Gerar link Cadastro
            </button>
            {(qtdCompanies > 1) && (
              <>
                <button onClick={() => setAddCompanyModalVisible(true)} className="menu-option">
                  Adicionar Empresa
                </button>
                <button onClick={handleTelegramQrCode} className="menu-option">
                  QrCode Telegram
                </button>
              </>
            )}
            <button onClick={handleAddClient} className="menu-option">
              Adicionar Cliente
            </button>
            <button onClick={() => setSelectedMenu('graficos')} className="menu-option">
              Gráficos
            </button>
            <button onClick={() => setSelectedMenu('relatorios')} className="menu-option">
              Relatórios
            </button>
            <button onClick={() => setSelectedMenu('avaliacoes')} className="menu-option">
              Avaliações
            </button>
            <button onClick={() => setSelectedMenu('importacaoContatos')} className="menu-option">
              Contatos Importados
            </button>
          </div>
        )}
      </nav>

      <section>{renderContent()}</section>
      <EditClientModal
        client={clientToEdit}
        visible={editModalVisible}
        onClose={handleEditModalClose}
        onClientUpdated={handleClientUpdated}
      />
      <RequestResgateModal
        promo={selectedPromo}
        client={clientForResgate}
        visible={resgateModalVisible}
        onClose={handleResgateModalClose}
        onResgateCompleted={handleResgateCompleted}
      />
      <LaunchPointsModal
        client={clientForPoints}
        visible={pointsModalVisible}
        onClose={handlePointsModalClose}
        onPointsLaunched={handlePointsLaunched}
      />
      <AddClientModal
        isOpen={addClientModalVisible}
        onClose={handleAddClientModalClose}
        onClientAdded={handleClientAdded}
      />
      <AddCompanyModal
        isOpen={addCompanyModalVisible}
        onClose={() => setAddCompanyModalVisible(false)}
      />
      <EditCompanyModal
        isOpen={editCompanyModalVisible}
        company={companyToEdit}
        onClose={handleEditCompanyModalClose}
        onCompanyUpdated={handleCompanyUpdated}
      />
      <AddAlertModal
        isOpen={createAlertFromFilterModalVisible}
        onClose={() => setCreateAlertFromFilterModalVisible(false)}
        onAddAlert={() => showAlert('success', 'Alerta criado com sucesso!')}
        initialRecipients={filterRecipients}
      />
      <GenerateLinkModal
        isOpen={generateLinkModalVisible}
        onClose={() => {
          setGenerateLinkModalVisible(false);
          setClientForRegistrationLink(null);
        }}
        company={currentCompany}
        client={clientForRegistrationLink}
      />
      <ClientHistoryModal
        client={clientForHistory}
        visible={historyModalVisible}
        onClose={handleHistoryModalClose}
      />
      <SelectPromoModal
        visible={selectPromoModalVisible}
        onClose={() => setSelectPromoModalVisible(false)}
        onPromoSelect={handlePromoSelectedForResgate}
      />
      <ClientAnnotationsModal
        client={clientForAnnotations}
        visible={annotationsModalVisible}
        onClose={handleAnnotationsModalClose}
      />

      {whatsappModalVisible && (
        <div className="modal-overlay">
          <div className="modal-content small-modal">
            <button onClick={handleCloseWhatsappModal} className="modal-close-button" type="button">
              &times;
            </button>
            <h3>Enviar WhatsApp</h3>
            <p style={{ marginTop: 0 }}>
              Cliente: <strong>{clientForWhatsapp?.nome || 'N/A'}</strong>
            </p>

            <div className="label-style">
              <label htmlFor="whatsappAlert">Alerta:</label>
              <select
                id="whatsappAlert"
                value={selectedWhatsappAlertId}
                onChange={handleWhatsappAlertChange}
                className="input-style"
                disabled={whatsappAlertsLoading}
              >
                <option value="">Digitar mensagem</option>
                {whatsappAlerts.map((alert) => (
                  <option key={alert.id} value={alert.id}>
                    {alert.nome}
                  </option>
                ))}
              </select>
            </div>

            <div className="label-style">
              <label htmlFor="whatsappMessage">Mensagem:</label>
              <textarea
                id="whatsappMessage"
                value={whatsappMessage}
                onChange={(e) => setWhatsappMessage(e.target.value)}
                className="input-style"
                rows={5}
                placeholder="Digite a mensagem para o cliente"
              />
            </div>

            {whatsappAlertsLoading && (
              <p style={{ marginTop: 0 }}>Carregando alertas...</p>
            )}

            <div className="modal-actions">
              <button onClick={handleSendWhatsappMessage} className="button-style" type="button">
                Enviar
              </button>
              <button onClick={handleCloseWhatsappModal} className="button-style cancel" type="button">
                Cancelar
              </button>
            </div>
          </div>

          {whatsappConfirmVisible && (
            <div className="modal-overlay">
              <div className="modal-content small-modal">
                <h3 style={{ borderBottom: '2px solid #C8A2C8', paddingBottom: '5px' }}>
                  Confirmar envio
                </h3>
                <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                  <p><strong>Cliente:</strong> {clientForWhatsapp?.nome || 'N/A'}</p>
                  <p><strong>Telefone:</strong> {clientForWhatsapp?.telefone || 'N/A'}</p>
                </div>
                <p style={{ marginBottom: '20px', color: '#666' }}>
                  Tem certeza que deseja enviar esta mensagem pelo WhatsApp?
                </p>
                <p style={{ marginBottom: '20px', color: '#d32f2f', fontWeight: 'bold' }}>
                  Essa mensagem será enviada em nome da conta logada no computador, verifique se está usando um número comercial de sua loja.
                </p>
                <div style={{ marginTop: '15px' }}>
                  <button
                    onClick={handleConfirmWhatsappSend}
                    className="button-style"
                    style={{ marginRight: '10px' }}
                    type="button"
                  >
                    Confirmar
                  </button>
                  <button
                    onClick={handleCancelWhatsappConfirmation}
                    className="button-style cancel"
                    type="button"
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      <AlertModal
        open={alertOpen}
        type={alertType}
        message={alertMessage}
        onClose={() => setAlertOpen(false)}
      />
      <TelegramQrCodeModal
        isOpen={telegramQrModalVisible}
        onClose={() => setTelegramQrModalVisible(false)}
        telegramData={telegramQrData}
        isLoading={telegramQrLoading}
        error={telegramQrError}
      />
      <Footer />
    </div>
  );
}

export default StoreOwnerDashboard;
